import fr from 'facet-rest';

const AccountRequestSummaryTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
    },
  })
  .nameOverride('householdId', { ordinal: 1, hidden: false, prompt: 'HHID' })
  .nameOverride('accountId', { ordinal: 2, hidden: false })
  .nameOverride('status', { ordinal: 4, hidden: false });

const AchRelationshipResourceOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
    },
    hidden: true,
  })
  .nameOverride('bankRoutingNumber', { ordinal: 1, hidden: false })
  .nameOverride('bankAccount', { ordinal: 2, hidden: false })
  .nameOverride('bankAccountOwnerName', { ordinal: 3, hidden: false })
  .nameOverride('bankAccountType', { ordinal: 4, hidden: false })
  .nameOverride('nickname', { ordinal: 5, hidden: false })
  .nameOverride('status', { ordinal: 6, hidden: false })
  .nameOverride('statusDetails', { ordinal: 7, hidden: false })
  .nameOverride('lastUpdated', { ordinal: 8, hidden: false })
  .nameOverride('creationTime', { ordinal: 9, hidden: false })
  .nameOverride('errorCode', { ordinal: 10, hidden: false })
  .nameOverride('errorMessage', { ordinal: 11, hidden: false });

export {
  AccountRequestSummaryTableOverride,
  AchRelationshipResourceOverride,
};
